import PropTypes from 'prop-types'
import { WeLoveThisGamePageQuery, WE_LOVE_THIS_GAME_QUERY } from '@layouts/we-love-this-game'
import { fetchSSRData } from '@lib/ssr-fetch'

function WeLoveThisGame(props) {
  const { data: ssrData, ...restProps } = props
  return <WeLoveThisGamePageQuery {...restProps} slug="adm" ssrData={ssrData} />
}

WeLoveThisGame.propTypes = {
  data: PropTypes.object,
}

WeLoveThisGame.getInitialProps = async ({ query }) => fetchSSRData({
  query,
  graphqlQuery: WE_LOVE_THIS_GAME_QUERY,
  variables: { slug: 'adm' },
  transform: (data) => data?.weLoveThisGameCollection?.items[0] || null,
})

export default WeLoveThisGame
